var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

// eslint-disable-next-line no-restricted-imports

import { LaunchDarklyProject } from '@square/ember-features/protos/squareup/feature/relay/flags/message/launch_darkly_project';
import { DataType } from '@square/ember-features/protos/squareup/feature/relay/common/data_type';
import * as Sentry from '@sentry/browser';
import { createGiftingEligibleUrl } from '@square/dashboard-items-data/utils/sites/weebly';
import { jsonPost } from '@square/dashboard-utilities/utils/xhr';
import { getCookie } from '@square/dashboard-utilities/utils/cookies';
export let Feature = /*#__PURE__*/function (Feature) {
  Feature[Feature["ADVANCED_CATEGORIES_BETA"] = 1] = "ADVANCED_CATEGORIES_BETA";
  return Feature;
}({});
export const PREORDERING_FEATURE_KEY = 'ecom_preorders';
export const MODIFIER_IMAGES_FEATURE_KEY = 'modifier_images';
export const GIFTING_OPTION_FEATURE_KEY = 'com_gifting';
export const ORDER_ITEM_QUANTITY_LIMIT_FEATURE_KEY = 'order_item_quantity_limit';
export const SCHEDULED_ACTIONS_FEATURE_KEY = 'product_scheduled_actions';
const LAUNCH_DARKLY_FEATURE_FLAGS = [{
  flagName: 'catalog/remove_item_fpref_ids',
  project: LaunchDarklyProject.PIE,
  type: DataType.BOOLEAN
}, {
  flagName: 'ecom/eligible_for_advanced_categories',
  project: LaunchDarklyProject.PIE,
  type: DataType.BOOLEAN
}, {
  flagName: 'catalog/item_gifting_enabled',
  project: LaunchDarklyProject.PIE,
  type: DataType.BOOLEAN
}];
let CatalogFeatures = (_dec = service('chamber/chamber-ajax'), (_class = class CatalogFeatures extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "catalogSentry", _descriptor, this);
    _initializerDefineProperty(this, "chamberService", _descriptor2, this);
    _initializerDefineProperty(this, "features", _descriptor3, this);
    _initializerDefineProperty(this, "userInfo", _descriptor4, this);
    _initializerDefineProperty(this, "weeblyUserData", _descriptor5, this);
    _initializerDefineProperty(this, "hasStartedInitialization", _descriptor6, this);
    _initializerDefineProperty(this, "hasFailedEligibilityRequest", _descriptor7, this);
    _initializerDefineProperty(this, "hasFetchedGiftingEligibilitySuccessfully", _descriptor8, this);
    _initializerDefineProperty(this, "hasInitiallyLoadedFlags", _descriptor9, this);
    _initializerDefineProperty(this, "isEligibleToSeeGiftingOptionRow", _descriptor10, this);
  }
  /**
   * Gets values for Catalog flags
   * @param reload - reload all flag values
   */
  async initialize(reload = false) {
    if (!this.hasStartedInitialization && !this.hasInitiallyLoadedFlags || reload) {
      this.hasStartedInitialization = true;
      try {
        await this.weeblyUserData.loadWeeblyData({
          fetchStoreData: false
        });
      } catch (errors) {
        this.catalogSentry.captureMessage('Error while loading Weebly user data', {
          extra: {
            errors
          },
          level: Sentry.Severity.Warning
        });
      }
      try {
        await this.getLDValues({
          setFlags: true
        });
        this.hasInitiallyLoadedFlags = true;
      } catch (errors) {
        this.catalogSentry.captureMessage('Error while loading LD flags', {
          extra: {
            errors
          },
          level: Sentry.Severity.Warning
        });
      }
      this.hasStartedInitialization = false;
    }
  }
  get isEcomEligibleForAdvancedCategoriesMigration() {
    if (this.weeblyUserData.hasSquareOnlineFetchError) {
      // we cannot determine seller status for non-404 errors, so assume is Square Online for categories use cases
      return false;
    }
    const weeblyUserInfo = this.weeblyUserData.getProperty('weeblyUserInfo');
    return this.features.isEnabled('ecom/eligible_for_advanced_categories') && weeblyUserInfo && !weeblyUserInfo.dtc_only && weeblyUserInfo?.uses_advanced_categories === false;
  }

  // already existing square online seller before advanced categories M1
  get isSoUserWithLimitedAdvancedCategories() {
    if (this.weeblyUserData.hasSquareOnlineFetchError) {
      // we cannot determine seller status for non-404 errors, so assume is Square Online for categories use cases
      return true;
    }
    const weeblyUserInfo = this.weeblyUserData.getProperty('weeblyUserInfo');
    return weeblyUserInfo && !weeblyUserInfo.dtc_only && weeblyUserInfo.uses_advanced_categories === false;
  }
  get isSoUserWithAdvancedCategories() {
    return this.weeblyUserData.getProperty('isWeeblyUser') && !this.isSoUserWithLimitedAdvancedCategories;
  }
  get isEligibleForItemGifting() {
    return this.weeblyUserData.getProperty('isWeeblyUser') && this.isEligibleToSeeGiftingOptionRow && this.features.isEnabled('catalog/item_gifting_enabled');
  }
  async getLDValues(options) {
    const attributes = {
      country: this.userInfo.countryCode,
      platform: 'web',
      product: 'dashboard',
      locale: window.navigator.language.split('-')[0],
      'ecom.is_square_online': true,
      'ecom.adv_cat_m3_cohort': this.weeblyUserData.weeblyUserInfo?.advanced_categories_migration_cohort ?? ''
    };
    const evaluatedFlags = await this.features.evaluate(LAUNCH_DARKLY_FEATURE_FLAGS, this.userInfo.merchantToken, attributes, options.setFlags);
    return evaluatedFlags;
  }
  async loadGiftingEligibility(reload = false) {
    try {
      if (this.features.isEnabled('catalog/item_gifting_enabled') && this.weeblyUserData.getProperty('isWeeblyUser') && (!this.hasFetchedGiftingEligibilitySuccessfully || reload)) {
        const response = await jsonPost(createGiftingEligibleUrl(), {
          headers: {
            'X-CSRF-Token': getCookie('_js_csrf')
          }
        });
        this.isEligibleToSeeGiftingOptionRow = response.response.data.is_eligible;
        this.hasFetchedGiftingEligibilitySuccessfully = true;
      }
    } catch (errors) {
      this.hasFailedEligibilityRequest = true;
      this.catalogSentry.captureMessage('Error while fetching seller gifting eligibility', {
        extra: {
          errors
        },
        level: Sentry.Severity.Warning
      });
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "catalogSentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "chamberService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "weeblyUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasStartedInitialization", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "hasFailedEligibilityRequest", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "hasFetchedGiftingEligibilitySuccessfully", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "hasInitiallyLoadedFlags", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isEligibleToSeeGiftingOptionRow", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class));
export { CatalogFeatures as default };